import React, { ReactNode } from 'react';
import colors from 'src/integration/styles/colors';
import BodyText from 'src/presentation/components/ui/BodyText';
import styled, { css } from 'styled-components';

export type StatusType = 'Normal' | 'Warning' | 'Error';

interface ComponentProps extends Component {
  children: ReactNode;
  type?: StatusType;
}

const Root = styled.div<{ $type?: StatusType }>`
  ${({ $type }) => css`
    border: 1px solid ${colors.text.info};
    padding: 2px 16px;
    border-radius: 2px;
    color: ${colors.text.info};
    min-width: 80px;
    * {
        color: ${colors.text.info};
    }

    ${$type === 'Normal' &&
      css`
          border: 1px solid ${colors.text.info};
          color: ${colors.text.info};
          * {
              color: ${colors.text.info};
          }
    `}
    
    ${$type === 'Warning' &&
    css`
          border: 1px solid ${colors.text.warning};
          color: ${colors.text.warning};
          * {
              color: ${colors.text.warning};
          }
    `}
    ${$type === 'Error' &&
    css`
          border: 1px solid ${colors.text.danger};
          color: ${colors.text.danger};
          * {
              color: ${colors.text.danger};
          }
    `}
  `}
`;

const Status = ({ className, type, children }: ComponentProps) => {
  return (
    <Root className={className} $type={type}>
      <BodyText level={'b2-reg'}>{children}</BodyText>
    </Root>
  );
};

export default Status;
